import React from "react";
import SectionBlock from "../../../../global/components/FeatureCard/SectionBlock";
import scheduleManagement from "../../../../assets/images/eventScheduleManage/schedule-management.png";
import eventAutomation from "../../../../assets/images/eventScheduleManage/event-automation.png";

const PAGE_X = "px-6 lg:px-[120px]";

const sections = [
  {
    image: scheduleManagement,
    label: "Advanced Schedule Management for Automated Access Control",
    description:
      "The Schedule feature enables administrators to define precise time-based automation rules that control when doors unlock, auxiliary outputs activate, and system operations execute across daily, weekly, monthly, or one-time intervals. Schedules combine specific time ranges with designated days of the week, supporting complex patterns including holiday groups that automatically adjust access permissions. The system includes an 'Always' default schedule (00:00-23:59, seven days) and advanced time-sync options including Dawn-to-Dusk and Dusk-to-Dawn automation based on geographic coordinates. Schedule Actions link these time definitions to physical devices, allowing administrators to configure automatic door unlocking, relay activation, or lockset control during designated periods, eliminating manual intervention while maintaining strict temporal security boundaries.",
    imageLeft: true,
    imageBg: "#ffffff",
    textBg: "#f8f8f8",
    bodyColor: "#5b5b5b",
    imageMaxWidth: "599px",
    sectionHeight: "540px",
  },
  {
    image: eventAutomation,
    label: "Event-Driven Automation and Response Management",
    description:
      "The Event Action feature delivers real-time automation by defining trigger-response relationships that execute predefined actions when specific system events occur within scheduled time windows. Administrators configure event logic by selecting event sources (doors, regions, auxiliary inputs, elevators, locksets, facegates, intercoms, triggers, threats) and assigning corresponding actions including door control, video recording with event tagging, mobile notifications, auxiliary output activation, and threat level escalation. When a monitored event triggers—such as forced door open or unauthorized access attempt—the system automatically executes associated actions like capturing tagged video footage, sending push notifications to security personnel, or securing adjacent zones. Each Event Action operates within assigned schedule boundaries, ensuring automated responses align with operational hours and security protocols while creating comprehensive audit trails for compliance documentation",
    imageLeft: false,
    imageBg: "#ffffff",
    textBg: "#f8f8f8",
    bodyColor: "#5b5b5b",
    imageMaxWidth: "590px",
    sectionHeight: "640px",
    textAlign: "right",
  },
];

export const ScheduleEventActionContent = () => (
  <div className="bg-white w-full">
    <section
      className={`bg-white flex flex-col items-center justify-center gap-6 ${PAGE_X} pt-28 sm:pt-24 min-h-[258px] text-center`}
    >
      <h1 className="text-black text-[32px] font-medium font-['Inter'] leading-normal max-w-[1004px]">
        Intelligent Schedule & Event Automation
      </h1>
      <p className="text-[#5b5b5b] text-[20px] font-medium font-['Poppins'] leading-normal max-w-[792px]">
        Streamline access operations with time-based controls, automated
        responses, and real-time security event management.
      </p>
    </section>

    <div className="w-full bg-white mt-6">
      {sections.map((section) => (
        <SectionBlock key={section.label} {...section} />
      ))}
    </div>
  </div>
);
